export default "__VITE_ASSET__LV9NcOLG__"